/**
 * The client side port should provide these methods.
 */
export class AbstractSharedSyncClientProvider {
}
//# sourceMappingURL=AbstractSharedSyncClientProvider.js.map